






































import Base from './Base.vue';
import { RozsahDate } from '../constants';

export default Base.extend({
	name: 'TrzbyNORApodleKoduMarketu',
	components: {
		BaseFilterSestav: Base,
	},
	created() {
		this.RozsahDate = RozsahDate.casMinulyMesic;
	},
});
